import { Image, View } from "react-native";
import { FileText, Pencil } from "lucide-react-native";
import { MoonEmptyState, SoftSecondaryButton } from "@louise/moon-ui";
import { useTranslations } from "@src/packages/i18n";
import { MEDICAL_DEDUCTION_TAX_YEAR } from "@src/packages/costs/medicalExpenseDeduction";
import { EMBER } from "../../../onboarding/theme";

const TAX_DEDUCTION_ILLUSTRATION =
  require("../../../assets/images/tax-deduction-recap.png") as number;

type Props = {
  subtitle?: string;
  onOpenTaxInputs?: () => void;
  onOpenTaxReview?: () => void;
};

export default function TaxDeductionPotentialEmptyState({
  subtitle,
  onOpenTaxInputs,
  onOpenTaxReview,
}: Props) {
  const t = useTranslations();

  return (
    <MoonEmptyState
      illustration={
        <Image
          source={TAX_DEDUCTION_ILLUSTRATION}
          accessibilityLabel={t("costs.tax_review.deduction_illustration")}
          accessibilityIgnoresInvertColors
          resizeMode="contain"
          style={{ width: 76, height: 64, opacity: 0.82 }}
        />
      }
      title={t("costs.tax_review.potential_deduction_empty_title", {
        params: { tax_year: String(MEDICAL_DEDUCTION_TAX_YEAR) },
      })}
      subtitle={
        subtitle ?? t("costs.tax_review.potential_deduction_empty_body")
      }
      subtitleStyle={{ marginTop: -4 }}
      action={
        onOpenTaxInputs ? (
          <View
            style={{
              flexDirection: "row",
              gap: 8,
              width: "100%",
              alignSelf: "stretch",
              minWidth: 320,
            }}
          >
            <SoftSecondaryButton
              label={t("costs.tax_review.add_tax_inputs")}
              onPress={onOpenTaxInputs}
              leading={
                <Pencil
                  size={16}
                  color={EMBER.colors.textMid}
                  strokeWidth={1.8}
                />
              }
              flex={1}
            />
            {onOpenTaxReview ? (
              <SoftSecondaryButton
                label={t("costs.tax_review.tax_review_action")}
                onPress={onOpenTaxReview}
                leading={
                  <FileText
                    size={16}
                    color={EMBER.colors.textMid}
                    strokeWidth={1.8}
                  />
                }
                flex={1}
              />
            ) : null}
          </View>
        ) : undefined
      }
      style={{
        width: "100%",
        paddingVertical: 6,
        paddingHorizontal: 0,
      }}
    />
  );
}
